import { DecoratorFunction } from '@storybook/core/types';
import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';

export function axiosMock() {
  return new MockAdapter(axios, {
    delayResponse: 500,
    onNoMatch: 'throwException',
  });
}

export function axiosMockDecorator(init?: (mock: MockAdapter) => void): DecoratorFunction {
  return (storyFn, context) => {
    init?.(axiosMock());
    return storyFn(context);
  };
}
